import {
  ActiveType,
  ConversionListFormType,
  ConversionListType,
  ConversionItemType
} from 'models/pricing.model';
import { BaseMealFormType, MealPricingFormType } from 'models/pricing.model';
import { Dispatch, SetStateAction, createContext, useContext } from 'react';

export type PricingContextType = {
  conversionListFormData: ConversionListFormType[];
  setConversionListFormData: (Value: ConversionListFormType[]) => void;

  itemToEdit: ConversionListType[];
  setItemToEdit: Dispatch<SetStateAction<ConversionListType[]>>;

  active: ActiveType | null;
  setActive: (item: ActiveType | null) => void;
  step: number;
  setStep: (value: number) => void;
  selectedConversionItem: ConversionItemType | null;
  setSelectedConversionItem: (item: ConversionItemType | null) => void;

  baseMealsFormData: BaseMealFormType[];
  setBaseMealFormData: (Value: BaseMealFormType[]) => void;
  selectedBaseMeal: BaseMealFormType | null;
  setSelectedBaseMeal: (item: BaseMealFormType | null) => void;

  mealPricingFormData: MealPricingFormType[];
  setMealPricingFormData: (Value: MealPricingFormType[]) => void;
  selectedMealPricing: MealPricingFormType | null;
  setSelectedMealPricing: (item: MealPricingFormType | null) => void;
};

export const PricingContext = createContext({} as PricingContextType);

const usePricingContext = () => {
  const context = useContext(PricingContext);
  return context;
};

export default usePricingContext;
